import css from 'styled-jsx/css';

export default css`
    .ErrorMessage {
        bottom: 50px;
        width: 85%;
        text-align: center;
    }
`;
